import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import { FeatureFlagContextConsumer } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

const DefaultPricingModuleSection = loadable(() =>
  import(/* webpackChunkName: "default-pricing-module-section" */ './DefaultPricingModuleSection')
)
const AfsProductCarePricingModuleSection = loadable(() =>
  import(/* webpackChunkName: "afs-product-care-pricing-module-section" */ './AfsProductCarePricingModuleSection')
)
const TuClothingPricingModuleSection = loadable(() =>
  import(/* webpackChunkName: "tu-clothing-pricing-module-section" */ './TuClothingPricingModuleSection')
)

DefaultPricingModuleSection.displayName = 'DefaultPricingModuleSection' // maybe could be remove in version 5.14.3 after https://github.com/gregberge/loadable-components/pull/731/files
AfsProductCarePricingModuleSection.displayName = 'AfsProductCarePricingModuleSection'
TuClothingPricingModuleSection.displayName = 'TuClothingPricingModuleSection'

const PricingModuleSection = ({
  type,
  pricingModuleOptions,
  WISHLIST,
  SOLD_BY_ARGOS,
  breadcrumb,
  MONTHLY_PAYMENT_PLAN,
  propositions,
  showAttributeSelector,
  isTuMobileLayout,
  headingSection
}) => {
  switch (type) {
    case 'AFS':
      return (
        <AfsProductCarePricingModuleSection
          className='pdp-pricing-module'
          {...pricingModuleOptions}
          headingSection={headingSection}
        />
      )
    case 'TU_ON_ARGOS':
    case 'TU':
      return (
        <TuClothingPricingModuleSection
          className='pdp-pricing-module'
          {...pricingModuleOptions}
          type={type}
          isTuMobileLayout={isTuMobileLayout}
        />
      )
    default:
      return (
        <FeatureFlagContextConsumer>
          <DefaultPricingModuleSection
            className='pdp-pricing-module'
            {...pricingModuleOptions}
            WISHLIST={WISHLIST}
            SOLD_BY_ARGOS={SOLD_BY_ARGOS}
            breadcrumb={breadcrumb}
            MONTHLY_PAYMENT_PLAN={MONTHLY_PAYMENT_PLAN}
            propositions={propositions}
            showAttributeSelector={showAttributeSelector}
            headingSection={headingSection}
          />
        </FeatureFlagContextConsumer>
      )
  }
}

PricingModuleSection.propTypes = {
  type: PropTypes.string,
  pricingModuleOptions: PropTypes.object.isRequired,
  WISHLIST: PropTypes.bool,
  SOLD_BY_ARGOS: PropTypes.bool,
  breadcrumb: PropTypes.array,
  MONTHLY_PAYMENT_PLAN: PropTypes.bool,
  headingSection: PropTypes.element.isRequired
}

export default PricingModuleSection
